<template>
  <span
    :class="avatarClasses"
    v-bind="accessibilityAttributes"
    data-cy="ds-user-avatar"
  >
    <img
      v-if="contentType === 'image'"
      :class="DS_USER_AVATAR_CLASSES.Image"
      :src="props.src"
      :alt="props.alt ?? ''"
      data-cy="ds-user-avatar__image"
    />
    <span
      v-else-if="contentType === 'text'"
      :class="DS_USER_AVATAR_CLASSES.Text"
      data-cy="ds-user-avatar__text"
    >
      {{ props.text }}
    </span>
    <DSIcon
      v-else
      :class="DS_USER_AVATAR_CLASSES.Icon"
      :icon="props.iconName"
      :size="iconSize"
      appearance="filled"
      aria-hidden="true"
      data-cy="ds-user-avatar__icon"
    />
  </span>
</template>

<script setup lang="ts">
import DSIcon from "@/src/design_system/primitives/icon/components/DSIcon.vue";
import { DS_USER_AVATAR_CLASSES } from "@/src/design_system/data_display/user/constants/classes";
import { useDSUserAvatar } from "@/src/design_system/data_display/user/composables/useDSUserAvatar";
import { DSUserAvatarProps } from "@/src/design_system/data_display/user/types/avatarProps";

const props = defineProps<DSUserAvatarProps>();

const { accessibilityAttributes, avatarClasses, contentType, iconSize } = useDSUserAvatar(props);
</script>
